import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { EmojiService } from '@core/services/emoji.service';
import { LocalizationService } from '@core/services/localization.service';

@Component({
  selector: 'app-emoji-picker',
  templateUrl: './emoji-picker.component.html',
  styleUrls: ['./emoji-picker.component.scss'],
})
export class EmojiPickerComponent implements OnChanges {
  @Input() isDarkMode = false;
  @Input() isVisible = false;
  @Input() type: 'wide' | 'default' = 'default';
  
  @Output() emojiSelected = new EventEmitter<any>();
  @Output() closed = new EventEmitter<void>();

  protected emojiI18n = {
    search: this.translate.key('EMOJI.SEARCH'),
    emojilist: this.translate.key('EMOJI.EMOJILIST'),
    notfound: this.translate.key('EMOJI.NOTFOUND'),
    clear: this.translate.key('EMOJI.CLEAR'),
    categories: {
      search: this.translate.key('EMOJI.CATEGORIES.SEARCH'),
      recent: this.translate.key('EMOJI.CATEGORIES.RECENT'),
      people: this.translate.key('EMOJI.CATEGORIES.PEOPLE'),
      nature: this.translate.key('EMOJI.CATEGORIES.NATURE'),
      foods: this.translate.key('EMOJI.CATEGORIES.FOODS'),
      activity: this.translate.key('EMOJI.CATEGORIES.ACTIVITY'),
      places: this.translate.key('EMOJI.CATEGORIES.PLACES'),
      objects: this.translate.key('EMOJI.CATEGORIES.OBJECTS'),
      symbols: this.translate.key('EMOJI.CATEGORIES.SYMBOLS'),
      flags: this.translate.key('EMOJI.CATEGORIES.FLAGS'),
      custom: this.translate.key('EMOJI.CATEGORIES.CUSTOM'),
    },
    skintones: {
      1: this.translate.key('EMOJI.SKINTONES.1'),
      2: this.translate.key('EMOJI.SKINTONES.2'),
      3: this.translate.key('EMOJI.SKINTONES.3'),
      4: this.translate.key('EMOJI.SKINTONES.4'),
      5: this.translate.key('EMOJI.SKINTONES.5'),
      6: this.translate.key('EMOJI.SKINTONES.6'),
    },
  };

  constructor(
    private emojiService: EmojiService,
    private translate: LocalizationService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isVisible']?.currentValue === true &&
      !changes['isVisible'].previousValue
    ) {
      this.logEmojiPickerOpened();
      this.updateEmojiMartTitle();
    }
  }

  onEmojiSelect(event: any): void {
    this.emojiSelected.emit(event);
  }

  closeEmojiPicker(): void {
    this.closed.emit();
  }

  private logEmojiPickerOpened(): void {
    this.emojiService.logEmojiPickerOpened();
  }

  private updateEmojiMartTitle(): void {
    requestAnimationFrame(() => {
      const titleLabel = document.querySelector('.emoji-mart-title-label');
      if (titleLabel && titleLabel.textContent) {
        titleLabel.textContent = this.translate.key('EMOJI.TITLE');
      }
    });
  }
}
